const envApiBaseUrl = process.env.REACT_APP_API_BASE_URL || "";

function resolveApiBaseUrl() {
  if (process.env.NODE_ENV !== "production") {
    if (envApiBaseUrl) return envApiBaseUrl;
    if (typeof window !== "undefined") return window.location.origin;
    return "";
  }
  if (typeof window === "undefined") {
    return envApiBaseUrl;
  }
  return window.location.origin;
}

export const API_BASE_URL = resolveApiBaseUrl();
